// extracted by mini-css-extract-plugin
module.exports =  {"spinner":"fEqPuJAuu2qiSj8t5EUH"};